import { Image, ImageProps } from 'theme-ui'

const Merkl = (props: ImageProps) => {
  return <Image width={16} src="/svgs/merkl.svg" {...props} />
}
export default Merkl
